module.exports = __webpack_public_path__ + "img/btfs_logo.585ff4b4.png";